module.exports = __webpack_public_path__ + "img/1484581191.631f33f7.jpg";